// 接龙vip
// module.exports = {
//   /* 小程序的名称 */
//   appletsName: "接龙加加 - 免费微信接龙报名小程序平台",
//   AppID: "wx1e899bddb256a5ca",
//   isVip: false,
//   appType: 0, //0 接龙普通 1接龙vip 2报名普通 3报名vip 以此类推
//   appletBannerImage: "",
//   appletLogoImage:
//     "https://ossfastmake.xlkapp.com//12jielong/lsyJL/jljiajia.svg",
// };

// 报名管家
module.exports = {
  /* 小程序的名称 */
  appletsName: "报名管家 - 免费微信接龙报名小程序平台",
  AppID: "wx7d8daf6d777947a2",
  isVip: false,
  appType: 2,
  appletBannerImage: "",
  appletLogoImage:
    "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bmgjlogo.png",
};

// 报名管家VIP
// module.exports = {
//   /* 小程序的名称 */
//   appletsName: "报名管家 - 免费微信接龙报名小程序平台",
//   AppID: "wx7d8daf6d777947a2",
//   isVip: true,
//   appType: 3,
//   appletBannerImage: "",
//   appletLogoImage:
//     "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bmgjlogo.png",
// };
